import { linearModel } from "../components/data/methodsData";
import { SHARMA_TABLE_CATALOG_KEYS } from "../config/sharmaReportsConfig";

export const contentTypeEnum = {
  nothing: 1,
  newsList: 2,
  newsDetail: 3,
  graph: 4,
  table: 5,
  text: 6,
  simulationTable: 7,
  historicalRiskFactorDetail: 8,
  customRiskCalculation: 9,
  riskHistoricalList: 10,
  /** Sharma column/stacked charts (drawdowns, attribution) */
  sharmaReportChart: 11,
};

/** Sharma table catalog keys only (strings); data is loaded from the API, not from demo objects. */
export const TABLE_NAMES = Object.freeze(
  Object.fromEntries(SHARMA_TABLE_CATALOG_KEYS.map((k) => [k, k]))
);

export const METHOD_NAMES = {
  "Longitudinal Monte Carlo": linearModel,
};

export const SIMULATION_MAP = {
  runBenchmarkSimulation: "simulation2",
  runNoARSimulation: "simulation3",
  runBenchmarkNoAR: "simulation4",
};
